<template>

<div class="internal">

    <div class="internal-head">

        <div class="internal-head-logo"><span>ADNAT</span></div>

        <div class="internal-head-text">

            <h1>Privacy Policy</h1>

            <p>This privacy policy is applicable to the ADNAT app (hereinafter referred to as “Application”) for mobile devices, which was developed by Virtual Health SHED Limited (hereinafter referred to as “Service Provider”) as a a Free service. This service is provided “AS IS”.</p>

            <p><b>What information does the Application obtain and how is it used?</b></p>

            <p><b>User Provided Information</b></p>

            <p>The Application acquires the information you supply when you download and register the Application. Registration with the Service Provider is not mandatory. However, bear in mind that you might not be able to utilise some of the features offered by the Application unless you register with them.</p>

            <p>The Service Provider may also use the information you provided them to contact you from time to time to provide you with important information, required notices and information related to your responses to the ADNAT questionnaire.</p>


            <p><b>Automatically Collected Information</b></p>

            <p>In addition, the Application may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile devices unique device ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browsers you use, and information about the way you use the Application. These details are not linked to your ADNAT questionnaire responses in any way, but are used to diagnoses technical issues with the Application.</p>


            <p><b>Does the Application collect precise real time location information of the device?</b></p>

            <p>This Application does not gather precise information about the location of your mobile device.</p>


            <p><b>Do third parties see and/or have access to information obtained by the Application?</b></p>

            <p>Only aggregated, psudoanonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.</p>

            <p>In order to use the ADNAT application, users will have already consented to engaging in a service evaluation to use the app. Additional details for all participants of the service evaluation will have been sent to each individual with an access code to use ADNAT, along with details of the partners who can analyse the data submitted by the ADNAT Application and how that data is used.</p>

            <p>Please note that the Application utilises third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:</p>

            <p><a href="https://www.google.com/policies/privacy/" target="_blank">Google Play Services</a></p>
            <p>The Service Provider may disclose User Provided and Automatically Collected Information:</p>

            <p>as required by law, such as to comply with a subpoena, or similar legal process;</p>
            <p>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;</p>
            <p>with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.</p>
            
            <p><b>What are my opt-out rights?</b></p>

            <p>You can halt all collection of information by the Application easily by uninstalling the Application. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.</p>


            <p><b>Data Retention Policy, Managing Your Information</b></p>

            <p>The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. The Service Provider will retain Automatically Collected information for up to 24 months and thereafter may store it in aggregate. If you’d like the Service Provider to delete User Provided Data that you have provided via the Application, please contact them at info@vhshed.com and we will respond in a reasonable time. Please note that some or all of the User Provided Data may be required in order for the Application to function properly.</p>


            <p><b>Children</b></p>

            <p>The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.</p>

            <p>The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (info@vhshed.com) so that they will be able to take the necessary actions.</p>


            <p><b>Security</b></p>

            <p>The Service Provider are concerned about safeguarding the confidentiality of your information. The Service Provider provide physical, electronic, and procedural safeguards to protect information we process and maintain. For example, we limit access to this information to authorised employees and contractors who need to know that information in order to operate, develop or improve their Application. Please be aware that, although we endeavour provide reasonable security for information we process and maintain, no security system can prevent all potential security breaches.</p>


            <p><b>Changes</b></p>

            <p>This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.</p>

            <p>This privacy policy is effective as of 2024-12-19</p>


            <p><b>Your Consent</b></p>

            <p>By using the Application, you are giving your consent to the Service Provider processing of your information as set forth in this Privacy Policy now and as amended by us. “Processing,” means using cookies on a computer/hand held device or using or touching information in any way, including, but not limited to, collecting, storing, deleting, using, combining and disclosing information.</p>


            <p><b>Contact us</b></p>

            <p>If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at info@vhshed.com.</p>

        </div>

    </div>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.internal {
    min-height: 100vh;
}

.internal-head {
    background-color: #fff;
    background-image: url(~@/assets/home.head.png);
    background-repeat: no-repeat;
    background-position: calc(100% + 100px) -200px;
    background-size: 560px 574px;
}

.is-tablet .internal-head {
    background-position: calc(100% + 200px) -200px;
}

.is-mobile .internal-head {
    background-image: none;
}

.internal-head-logo {
    position: absolute;
    top: 36px;
    left: calc(50% - 660px);
    width: 238px;
    height: 68px;
    background-image: url(~@/assets/logo.png);
    background-size: 238px 68px;
}

.is-narrow .internal-head-logo,
.is-tablet .internal-head-logo {
    left: 20px;
}

.is-mobile .internal-head-logo {
    left: 0px;
    width: 100%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
}

.internal-head-logo span {
    display: none;
}

.internal-head-text {
    max-width: 1000px;
    margin: 0px auto;
    padding: 200px 20px 40px 20px;
}

.is-mobile .internal-head-text {
    padding: 150px 20px 40px 20px;
}

.internal-head-text h1 {
    color: #425563;
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 32px;
}

.is-tablet .internal-head-text h1 {
    font-size: 32px;
}

.is-mobile .internal-head-text h1 {
    font-size: 26px;
}

.internal-head-text h2 {
    color: #425563;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
}

.internal-head-text p {
    color: #707070;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 20px;
}

.internal-head-text p b {
    font-weight: 700;
}

</style>
